
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/solution",
      function () {
        return require("private-next-pages/product/solution/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/solution"])
      });
    }
  